import { isAWSExternalActionRequest } from 'components/scenarios/utils/graph/nodes/typeguards'
import { ExternalActionPreviewSentinels } from 'types/api/reliability-tests/preview'
import {
  type ExternalActionRequest,
  ExternalActionRequestType
} from 'types/api/scenarios/scenario'
import {
  getAWSAutoscalingGroupNameFromASGArn,
  getAWSLoadBalancerNameFromLoadBalancerArn
} from 'utils/status-checks/status-check-integrations-util-aws'

export enum NodeSectionType {
  ExternalActions = 'ExternalActions',
  ExternalRollbacks = 'ExternalRollbacks',
  Observers = 'Observers',
  Nodes = 'Nodes'
}

const externalActionSentinelValues = new Set<string>(
  Object.values(ExternalActionPreviewSentinels)
)

export const NODE_SECTION_LABELS = {
  [NodeSectionType.ExternalActions]: 'External Steps',
  [NodeSectionType.ExternalRollbacks]: 'External Rollback Steps',
  [NodeSectionType.Observers]: 'Health Checks',
  [NodeSectionType.Nodes]: 'Gremlin Steps'
}

export function getExternalActionText(
  externalActionRequestType: ExternalActionRequestType
) {
  switch (externalActionRequestType) {
    case ExternalActionRequestType.DisableAWSAutoScalingGroups:
      return 'Disable'
    case ExternalActionRequestType.RemoveAWSSecurityGroups:
      return 'Remove'
    default:
      return null
  }
}

export function getExternalActionTargetPrefix(
  externalActionRequestType: ExternalActionRequestType,
  includeTransition = true
) {
  switch (externalActionRequestType) {
    case ExternalActionRequestType.DisableAWSAutoScalingGroups:
      return `ASG autoscaling${includeTransition ? ' on' : ''}`
    case ExternalActionRequestType.RemoveAWSSecurityGroups:
      return `Security Group${includeTransition ? ' from' : ''}`
    default:
      return null
  }
}

export function getResourceNameFromExternalActionRequest(
  externalActionRequest: ExternalActionRequest
) {
  if (isAWSExternalActionRequest(externalActionRequest)) {
    const { resourceArn, type } = externalActionRequest

    if (externalActionSentinelValues.has(resourceArn)) {
      return resourceArn
    }

    return type === ExternalActionRequestType.RemoveAWSSecurityGroups
      ? getAWSLoadBalancerNameFromLoadBalancerArn(resourceArn)
      : getAWSAutoscalingGroupNameFromASGArn(resourceArn)
  }

  return null
}
